@switch (specificTemplateName) {
  @case (WorkAndRestTableEnum.Matrix) {
    <app-work-and-rest-template
      [element]="element"
      [columnName]="columnName"
    ></app-work-and-rest-template>
  }
  @case (WorkAndRestTableEnum.WorkApproval) {
    <app-work-and-rest-work-approval-template
      [element]="element"
      [columnName]="columnName"
      [buttonFunctions]="buttonFunctions"
    ></app-work-and-rest-work-approval-template>
  }
  @case (WorkAndRestTableEnum.SignOff) {
    <app-work-and-rest-sign-off-template
      [element]="element"
      [columnName]="columnName"
    ></app-work-and-rest-sign-off-template>
  }
  @case (WorkAndRestTableEnum.WorkAndRest) {
    <app-work-and-rest-template
      [element]="element"
      [columnName]="columnName"
      [buttonFunctions]="buttonFunctions"
    ></app-work-and-rest-template>
  }
  @case (WorkAndRestTableEnum.WorkPlanValidation) {
    <app-work-plan-validation-template
      [element]="element"
      [columnName]="columnName"
    ></app-work-plan-validation-template>
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
